import {
  RedirectContainers,
  ResultAction,
  ResultActionContainers,
  WindowNames,
} from '@cashier/cashier-model';

interface HiddenFormCollectorInput {
  resultAction: ResultAction;
  paymentMethodContainer: RedirectContainers;
}

interface HiddenFormConfiguration {
  actionUrl: string;
  fields: { name: string; value: string | number }[];
  target: string;
}

export const toHiddenFormConfiguration = ({
  resultAction,
  paymentMethodContainer,
}: HiddenFormCollectorInput): HiddenFormConfiguration | null => {
  if (!resultAction.url) {
    return null;
  }

  const { parameters, url } = resultAction;
  const getTarget = () => {
    const targetMap: { [containerType: string]: WindowNames } = {
      [RedirectContainers.IFRAME]: WindowNames.Iframe,
      [RedirectContainers.NEW_TAB]: WindowNames.Window,
      [RedirectContainers.NO_REDIRECT]: WindowNames.Window,
    };

    return targetMap[paymentMethodContainer];
  };

  const fields = Object.entries(parameters || {}).map(([k, v]) => {
    return { name: k, value: v };
  });

  return {
    actionUrl: url,
    fields,
    target: getTarget(),
  };
};
